import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './material-control-bar.styl'

export default class MaterialControlBar extends Component {
  static propTypes = {
    add: PropTypes.object,
    edit: PropTypes.object,
    clear: PropTypes.object,
    del: PropTypes.object,
    downloadComp: PropTypes.node
  }

  render() {
    const { add, edit, del, clear, downloadComp } = this.props

    return (
      <div className={styles.bar}>
        {edit && (
          <button type="button" className={styles.edit} onClick={edit.onClick}>
            <i className={`ico ico--edit ${styles.editIcon}`} />
            {edit.copy}
            <FormattedMessage id={edit.intlKey} defaultMessage={edit.label} />
          </button>
        )}

        {del && (
          <button type="button" className={styles.delete} onClick={del.onClick}>
            <i className={`ico ico--delete ${styles.deleteIcon}`} />
            <FormattedMessage id={del.intlKey} defaultMessage={del.label} />
          </button>
        )}

        {clear && (
          <button
            type="button"
            className={styles.clear}
            onClick={clear.onClick}
          >
            <i className={`ico ico--close ${styles.clearIcon}`} />
            <FormattedMessage id={clear.intlKey} defaultMessage={clear.label} />
          </button>
        )}

        {add && (
          <button type="button" className={styles.add} onClick={add.onClick}>
            <i className={`ico ico--add ${styles.addIcon}`} />
            <FormattedMessage id={add.intlKey} defaultMessage={add.label} />
          </button>
        )}

        {downloadComp &&
          React.cloneElement(downloadComp, {
            wrapperClassName: styles.download,
            className: styles.downloadLink
          })}
      </div>
    )
  }
}
